import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "UPDATE_USER_SECONDARY_EMAIL_" }
);

export interface UpdateUserSecondaryEmailState extends IState {}

const INITIAL_STATE: UpdateUserSecondaryEmailState = {
  loading: false,
  error: null,
};

const request = (state: UpdateUserSecondaryEmailState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: UpdateUserSecondaryEmailState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: UpdateUserSecondaryEmailState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const updateUserSecondaryEmail = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const UpdateUserSecondaryEmailTypes = Types;
export const UpdateUserSecondaryEmailActions = Creators;
